import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:groupTripId|dayId|travelerId|journeyId|budgetId|expenseId|participantId|payerMemberId|recordedByMemberId|voidedByMemberId|memberId|ownerMemberId|creatorMemberId|createdByMemberId|conversationId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/** Private Journey expense ledger — Planning finance only (no split/payment modules). */
const corePath=(journeyId,groupTripId)=>`/travel/api/v1/journeys/${encodeURIComponent(journeyId)}/group-trips/${encodeURIComponent(groupTripId)}/accounting/expenses/entries`;
const closingPath=(j,g)=>corePath(j,g).replace(/\/entries$/, '/closing');
export const journeyExpenseApi = {
  closing: (j,g)=>travelClient.get(closingPath(j,g),snowflakeJson),
  closingExecute: (j,g,kind,body)=>travelClient.post(`${closingPath(j,g)}/${encodeURIComponent(kind)}`,body,snowflakeJson),
  closingLookup: (j,g,key)=>travelClient.get(`${closingPath(j,g)}/operations/${encodeURIComponent(key)}`,snowflakeJson),
  coreGroups: (journeyId)=>travelClient.get(`/travel/api/v1/journeys/${encodeURIComponent(journeyId)}/expense-groups`,snowflakeJson),
  coreLedger: (journeyId,groupTripId)=>travelClient.get(corePath(journeyId,groupTripId),snowflakeJson),
  coreCreate: (journeyId,groupTripId,body)=>travelClient.post(corePath(journeyId,groupTripId),body,snowflakeJson),
  coreSave: (journeyId,groupTripId,expenseId,body)=>travelClient.put(`${corePath(journeyId,groupTripId)}/${encodeURIComponent(expenseId)}`,body,snowflakeJson),
  coreConfirm: (journeyId,groupTripId,expenseId,body)=>travelClient.post(`${corePath(journeyId,groupTripId)}/${encodeURIComponent(expenseId)}/confirm`,body,snowflakeJson),
  list: (journeyId) => travelClient.get(
    travelEndpoints.journeyExpenses(journeyId),
    snowflakeJson,
  ),
  getSummary: (journeyId) => travelClient.get(
    travelEndpoints.journeyExpenseSummary(journeyId),
    snowflakeJson,
  ),
  get: (journeyId, expenseId) => travelClient.get(
    travelEndpoints.journeyExpense(journeyId, expenseId),
    snowflakeJson,
  ),
  create: (journeyId, body) => travelClient.post(
    travelEndpoints.journeyExpenses(journeyId),
    body,
    snowflakeJson,
  ),
  update: (journeyId, expenseId, body) => travelClient.patch(
    travelEndpoints.journeyExpense(journeyId, expenseId),
    body,
    snowflakeJson,
  ),
  void: (journeyId, expenseId, body) => travelClient.post(
    travelEndpoints.journeyExpenseVoid(journeyId, expenseId),
    body,
    snowflakeJson,
  ),
  shareToChat: (journeyId, expenseId, body = { confirm: true }) => travelClient.post(
    travelEndpoints.journeyExpenseChatShare(journeyId, expenseId),
    body,
    snowflakeJson,
  ),
};
